import { QueryFactory } from "../../../../Common";
export const QSaveSettings = QueryFactory("SaveSettings");
//# sourceMappingURL=QSaveSettings.js.map